import React, { createContext, useState } from 'react';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [globalState, setGlobalState] = useState({
    currentGroup: '',
    currentPage: '',
    preventScroll: false,
    openModal: '',
    exitHref: '',
    asocHref: '',
    shareLocationId: '',
    returnFocusTo: '',
    preventPlay: true,
    playingVideo: '',
    vimeoUrl: '',
    transcript: "/",
    videoActionQueue: '',
    textZoom: false,
    isiInteracted: false,
    isiExpanded: false,
    distributorsModalOpen: false,
    asocSearchCompleted: false,
    /** When opening referral modal from an ASOC result card, set this so the PDF Site section is prepopulated. */
    referralFormAsocProvider: null,
  });

  const updateGlobalState = () => {
    setGlobalState({ ...globalState });
  };

  return (
    <GlobalContext.Provider value={{ globalState, updateGlobalState }}>
      {children}
    </GlobalContext.Provider>
  );
};
